import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import * as Loadable from 'react-loadable'
import loading from '../../router/loading'
import './style.less'

const PureList: any[] = [
  {
    component: () => import('../../pages/AuthAdd/AuthAdd'),
    path: '/pure/add-auth',
    name: 'authAdd'
  },
  {
    component: () => import('../../pages/Register/Register'),
    path: '/pure/register',
    public: true
  },
  {
    component: () => import('../../pages/ForgetPassword/ForgetPassword'),
    path: '/pure/forgetPassword',
    public: true
  },
  {
    component: () => import('../../pages/Agreement/Agreement'),
    path: '/pure/agreement',
    public: true
  },
  {
    component: () => import('../../pages/Agreement/MktAgreement'),
    path: '/pure/mkt-agreement',
    public: true
  },
  {
    component: () => import('../../pages/Private/Private'),
    path: '/pure/privacy',
    public: true
  },
  {
    component: () => import('../../pages/Invalid/Invalid'),
    path: '/pure/invalid',
    public: true
  }
]

const NoPerm = () => import('../../components/NoPerm/NoPerm')

function PureApp(props: any) {
  const perms = useSelector((state: any) => state.user.perm)
  return (
    <div style={{height: '100%'}}>
      <Switch>
        {PureList.map(item => (
          <Route
            key={item.path}
            exact={true}
            path={item.path}
            component={
              (item.public || perms && perms.includes(item.name)) ?
              Loadable({
                loader: item.component,
                loading
              }) : 
              Loadable({
                loader: NoPerm,
                loading
              })
            }
          />
        ))}
      </Switch>
    </div>
  );
}

export default PureApp


// WEBPACK FOOTER //
// ./src/containers/PureApp/PureApp.tsx